import React, { useState } from 'react';
import { useTranslations } from 'use-intl';
import { toNamespaceKey, toTranslationKey } from '@/utils/translations';
import { Maximize, X } from 'react-feather';
import Button from '@/UIlibrary/Button/Button';

interface ExpandableTableProps {
	title: string;
	children: React.ReactNode;
	headerContent?: React.ReactNode;
	translationsKey?: string;
}

const ExpandableTable: React.FC<ExpandableTableProps> = ({
	title,
	children,
	headerContent,
	translationsKey = 'CreditBureau'
}) => {
	const t = useTranslations(toNamespaceKey(translationsKey));
	const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);

	return (
		<>
			<div className="max-w-full overflow-x-auto">
				{headerContent}
				<div className="flex items-center justify-between mb-4">
					<div className="flex-1"></div>
					<h3 className="text-lg font-semibold flex-1 text-center">{title}</h3>
					<div className="flex-1 flex justify-end">
						<Button
							size="small"
							color="gray"
							onClick={() => setIsFullscreenOpen(true)}
							startIcon={<Maximize size={16} />}
							label={t(toTranslationKey('ExpandTable'))}
						/>
					</div>
				</div>
				{children}
			</div>
			{isFullscreenOpen && (
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(16, 24, 40, 0.7)',
						zIndex: 1000,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						overflow: 'auto'
					}}
					onClick={(e) => {
						if (e.target === e.currentTarget) {
							setIsFullscreenOpen(false);
						}
					}}
				>
					<div
						style={{
							backgroundColor: 'white',
							borderRadius: '12px',
							boxShadow:
								'0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
							width: '95vw',
							maxWidth: '95vw',
							height: '95vh',
							maxHeight: '95vh',
							display: 'flex',
							flexDirection: 'column',
							position: 'relative',
							margin: 'auto',
							padding: '12px',
							boxSizing: 'border-box',
							overflow: 'hidden'
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<button
							onClick={() => setIsFullscreenOpen(false)}
							style={{
								position: 'absolute',
								top: '10px',
								right: '10px',
								background: 'none',
								border: 'none',
								fontSize: '24px',
								cursor: 'pointer',
								zIndex: 10
							}}
							aria-label="close-button"
						>
							<X size={24} />
						</button>
						<div className="text-center mb-3 flex-shrink-0">
							<h3 className="text-lg font-semibold">{title}</h3>
						</div>
						{headerContent && <div className="mb-4 flex-shrink-0">{headerContent}</div>}
						<div
							className="flex-1"
							style={{
								minHeight: 0,
								width: '100%',
								overflow: 'auto',
								overflowX: 'auto',
								overflowY: 'auto'
							}}
						>
							{children}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default ExpandableTable;
